// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-inputs .form-control {
  height: 40px;
}

.form-inputs .form-control:focus {
  box-shadow: none;
  border: 1px solid #000;
}

.form-control {
  width: 100%;
  min-width: 0;
}

.search-container {
  width: 100%;
  align-items: center;
  gap: 10px;
}

.add-source-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  height: 100%;
}

.add-icon {
  font-size: 2rem;
  cursor: pointer;
}

.add-source-text {
  font-size: 22px;
  font-weight: 400;
}

.search-icon {
  flex-shrink: 0;
  background-color: #333742;
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgb(210, 207, 207);
  border-radius: 16%;
  cursor: pointer;
}
.search-icon:hover {
  color: white;
  background-color: #000000;
  transition: all 0.4s ease-in-out;
}

::ng-deep .mat-tooltip {
  background-color: black !important; /* Ensure visibility */
  color: white !important; /* Tooltip text color */
  font-size: 14px; /* Adjust size if needed */
}

.tool-card {
  background: #ffffff;
  border-radius: 0.75rem;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* Added */
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tool-card:hover {
  transform: translateY(-0.3125rem);
  box-shadow: 0 5px 7px rgba(2, 56, 121, 0.6);
}

.card-icon {
  font-size: 2.5rem;
  color: #4a4a4a;
  margin-bottom: 0.9375rem;
}

.tool-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 0.625rem;
  /* Added */
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.tool-description {
  font-size: 0.875rem;
  color: #2c2c2c;
  margin-bottom: 1.25rem;
  line-height: 1.6;
  flex-grow: 1;
  /* Better Responsive Text */
  text-align: left;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

/* Button Styling */
.btn-open {
  background-color: #0060d6;
  font-size: 1rem;
  border-radius: 0.375rem;
  transition: background 0.3s ease-in-out;
  /* Keep original size */
  align-self: center;
}

.btn-open:hover {
  background-color: #1a1a86;
}

@media (max-width: 768px) {
  .search-container {
    width: 100%;
  }
  .add-source-container {
    justify-content: center;
  }
  .add-source-text {
    font-size: 18px;
  }
  .search-icon {
    padding: 10px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/security-zone/zone-management/zone/zone-search/zone-search.component.scss"],"names":[],"mappings":"AAyBA;EACI,YAAA;AAxBJ;;AA2BA;EACI,gBAAA;EACA,sBAAA;AAxBJ;;AA2BA;EACI,WAAA;EACA,YAAA;AAxBJ;;AA2BA;EACI,WAAA;EACA,mBAAA;EACA,SAAA;AAxBJ;;AA2BA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,YAAA;AAxBJ;;AA2BA;EACI,eAAA;EACA,eAAA;AAxBJ;;AA2BA;EACI,eAAA;EACA,gBAAA;AAxBJ;;AA4BA;EAEI,cAAA;EACA,yBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA3BJ;AA6BI;EACI,YAAA;EACA,yBAAA;EACA,gCAAA;AA3BR;;AA+BA;EACI,kCAAA,EAAA,sBAAA;EACA,uBAAA,EAAA,uBAAA;EACA,eAAA,EAAA,0BAAA;AA5BJ;;AAgCA;EACE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,qDAAA;EAEA,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,iCAAA;EACA,2CAAA;AA9BF;;AAiCA;EACE,iBAAA;EACA,cAAA;EACA,wBAAA;AA9BF;;AAiCA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EAEA,UAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;AAjCF;;AAoCA;EACE,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EAEA,YAAA;EAEA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AAnCF;;AAsCA,mBAAA;AACA;EACE,yBAAA;EACA,eAAA;EACA,uBAAA;EACA,uCAAA;EAEA,uBAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,yBAAA;AApCF;;AAwCA;EAEI;IACI,WAAA;EAtCN;EAyCE;IACI,uBAAA;EAvCN;EA0CE;IACI,eAAA;EAxCN;EA2CE;IACI,kBAAA;EAzCN;AACF","sourcesContent":["// .form-inputs{\n//     position:relative;\n// }\n// .form-inputs .form-control{\n//     height:40px; \n// }\n\n// .form-inputs .form-control:focus{\n//     box-shadow:none;\n//     border:1px solid #000;\n// }\n// .form-control {\n//     min-width: 250px;\n//     margin-right: 20px;\n// }\n\n// .form-inputs i{\n//     position:absolute;\n//     right:35px;\n//     top:10px;\n// }\n\n.form-inputs{\n    //position:relative;\n}\n.form-inputs .form-control{\n    height:40px; \n}\n\n.form-inputs .form-control:focus{\n    box-shadow:none;\n    border:1px solid #000;\n}\n\n.form-control {\n    width: 100%;\n    min-width: 0;\n}\n\n.search-container {\n    width: 100%;\n    align-items: center;\n    gap: 10px;\n}\n\n.add-source-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 12px;\n    height: 100%;\n}\n\n.add-icon {\n    font-size: 2rem;\n    cursor: pointer;\n}\n\n.add-source-text {\n    font-size: 22px;\n    font-weight: 400;\n}\n\n\n.search-icon{\n    //margin-top:1px;\n    flex-shrink: 0;\n    background-color: #333742; \n    //padding: 9px; \n    padding-left: 13px;\n    padding-right: 13px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    color: rgb(210, 207, 207);\n    border-radius:16%;\n    cursor: pointer;\n\n    &:hover{\n        color: white; \n        background-color: #000000;\n        transition: all 0.4s ease-in-out;\n    }\n}\n\n::ng-deep .mat-tooltip {\n    background-color: black !important; /* Ensure visibility */\n    color: white !important; /* Tooltip text color */\n    font-size: 14px; /* Adjust size if needed */\n  }\n\n\n.tool-card {\n  background: #ffffff;\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n  text-align: center;\n  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n  /* Added */\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.tool-card:hover {\n  transform: translateY(-0.3125rem);\n  box-shadow: 0 5px 7px rgba(2, 56, 121, 0.6);\n}\n\n.card-icon {\n  font-size: 2.5rem;\n  color: #4a4a4a;\n  margin-bottom: 0.9375rem;\n}\n\n.tool-title {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #000000;\n  margin-bottom: 0.625rem;\n\n  /* Added */\n  min-height: 50px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  text-align: center;\n}\n\n.tool-description {\n  font-size: 0.875rem;\n  color: #2c2c2c;\n  margin-bottom: 1.25rem;\n  line-height: 1.6;\n\n  flex-grow: 1;\n\n  /* Better Responsive Text */\n  text-align: left;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n\n/* Button Styling */\n.btn-open {\n  background-color: #0060d6;\n  font-size: 1rem;\n  border-radius: 0.375rem;\n  transition: background 0.3s ease-in-out;\n\n  /* Keep original size */\n  align-self: center;\n}\n\n.btn-open:hover {\n  background-color: #1a1a86;\n}\n\n\n@media (max-width: 768px) {\n\n    .search-container {\n        width: 100%;\n    }\n\n    .add-source-container {\n        justify-content: center;\n    }\n\n    .add-source-text {\n        font-size: 18px;\n    }\n\n    .search-icon {\n        padding: 10px 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
